import { useMultiAccountStore } from './multiAccount';

/** Never adopt legacy unscoped private data: its owner cannot be established from its key. */
export function accountStorageKey(key: string): string {
    const context = useMultiAccountStore.getState().context;
    return context
        ? `${key}:account:${context.accountId}:workspace:${context.workspaceId ?? 'account'}`
        : `${key}:anonymous`;
}
